export default __webpack_public_path__ + "static/media/blue-arrow-up-right-from-square.35ce5541.svg";